<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" header="Reasignar canal de origen" [style]="{ width: '480px' }" (onHide)="close()">
  <form [formGroup]="form" (ngSubmit)="submit()" class="form-stack">
    <div class="field field-flex">
      <label for="channelKey">*Nuevo canal:</label>
      <p-dropdown inputId="channelKey" formControlName="channelKey" [options]="(options$ | async) ?? []" optionLabel="label" optionValue="value" placeholder="Seleccionar canal" [style]="{ width: '100%' }"></p-dropdown>
    </div>
    <div class="field field-flex">
      <label for="reason">Motivo (opcional):</label>
      <textarea pInputTextarea id="reason" formControlName="reason" rows="3"></textarea>
    </div>
    <div class="form-action">
      <button pButton type="submit" label="Asignar" icon="pi pi-check" class="p-button-success" [disabled]="form.invalid" [style.width]="'100%'"></button>
    </div>
  </form>
</p-dialog>
<p-toast position="top-right"></p-toast>
